import { ERROR_TYPES } from 'Modules/Shared/constants';

export const getError = state => state.getIn(['app', 'error', 'error']);
export const getErrorType = state =>
  state.getIn(['app', 'error', 'errorType'], ERROR_TYPES.GENERIC);
